import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Icon from "sap/ui/core/Icon";

/**
 * @namespace vamos.cockpit.base.customcontrol
 */
export default class DisabledVariantIcon extends Control {

  static readonly metadata: MetadataOptions = {
    properties: {
      disabled: {
        type: "any",
        defaultValue: "",
      },
    },
    aggregations: {
      _icon: {
        type: "sap.ui.core.Icon",
        multiple: false,
        visibility: "hidden",
      },
    },
  };

  renderer = {
    apiVersion: 4,
    render: (rm: RenderManager, control: DisabledVariantIcon) => {
      rm.renderControl(control.getAggregation("_icon") as Control);
    },
  };

  public setDisabled(disabled: any) {
    this.setProperty("disabled", disabled, true);
    const icon:Icon = this.getAggregation("_icon") as Icon;
    icon.setVisible(!!disabled);
  }

  public init(): void {
    this.setAggregation("_icon", new Icon({ src: "sap-icon://warning", color: "#ffcc00", visible: false }));
  };

}